<div class="page-content-container h-100 mt-4">
  <div class="top-content">
    <div class="w-100">
      <button mat-stroked-button class="back-btn mb-3" type="button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        Back to List Bill Manager
      </button>
      <div class="sub-title ps-0 ps-lg-2 mb-4">{{ isEditMode ? 'Edit' : 'Create' }} Group List Bill</div>
    </div>
  </div>

  <div class="main-content">
    <form [formGroup]="form" class="w-100">

      <div class="form-columns mb-4">

        <!-- Left column (50%): core bill fields -->
        <div class="form-col">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Group Name</mat-label>
            <input matInput formControlName="name" />
            @if (form.controls.name.errors?.required) {
              <mat-error>Name is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Number of pay periods per year</mat-label>
            <input matInput type="number" min="1" formControlName="nPayPeriod" />
            @if (form.controls.nPayPeriod.errors?.required) {
              <mat-error>Number of pay periods is required</mat-error>
            }
          </mat-form-field>

          <div class="date-row">
            <mat-form-field appearance="outline">
              <mat-label>Start Date</mat-label>
              <input
                matInput
                appDateInputMask
                [matDatepickerFilter]="startDateFilter"
                [matDatepicker]="startDatePicker"
                formControlName="startDate" />
              @if (form.controls.startDate.errors?.required) {
                <mat-error>Start Date is required.</mat-error>
              }
              <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>End Date</mat-label>
              <input
                matInput
                appDateInputMask
                [matDatepickerFilter]="endDateFilter"
                [matDatepicker]="endDatePicker"
                formControlName="endDate" />
              <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
          </div>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Group size</mat-label>
            <input type="number" min="0" matInput formControlName="groupSize" />
            @if (form.controls.groupSize.errors?.required) {
              <mat-error>Group size is required</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Right column (50%): packages & region -->
        <div class="form-col">
          @if (packagesList.length) {
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Packages</mat-label>
              <mat-select formControlName="selectedPackages" multiple>
                <mat-select-trigger>
                  @if (form.controls.selectedPackages.value.length) {
                    {{form.controls.selectedPackages.value.length === 1 ? '1 package selected' : form.controls.selectedPackages.value.length + ' packages selected'}}
                  }
                </mat-select-trigger>
                @for (packageItem of packagesList; track packageItem) {
                  <mat-option [value]="packageItem.altName">{{packageItem.altName}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (isEditMode) {
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Loomis number</mat-label>
              <input type="number" matInput formControlName="loomisNum" />
            </mat-form-field>
          }
          @if (form.controls.selectedPackages.value.length) {
            @if (!showSelectedPackage && (!isEditMode || !hasSavedBenefits)) {
              <button mat-stroked-button color="primary" class="w-100 mb-3" type="button" (click)="applyUniformBenefitSelection()">
                Apply Uniform Benefit Selection to all employees
              </button>
            } @else {
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Selected package</mat-label>
                <mat-select formControlName="selectedPackage">
                  @for (altName of form.controls.selectedPackages.value; track altName) {
                    <mat-option [value]="altName">{{altName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          }
        </div>

      </div>

      @if (isLoadingBenefits) {
        <div class="mb-2">Loading benefits…</div>
      }
      @if (benefitGroupsByRegion.length) {
        <div class="benefits-section mb-3">
          <div class="benefits-columns">
            @for (rb of benefitGroupsByRegion; track rb.region.id) {
              <div class="benefits-column">
                <div class="region-header">
                  {{ rb.region.name }}@if (getRegionStatesLabel(rb.region); as label) { ({{ label }})}
                </div>
                <app-bill-package-content [benefitGroups]="rb.groups"></app-bill-package-content>
              </div>
            }
          </div>
        </div>
      }

      <div class="form-actions d-flex align-items-center justify-content-end pt-3">
        <button mat-button color="primary" class="btn-sm me-2" type="button" (click)="goBack()">Cancel</button>
        <button mat-raised-button color="primary" class="btn-sm" type="button" (click)="submit()">
          {{ isEditMode ? 'Edit' : 'Create' }} Group
        </button>
      </div>

    </form>
  </div>
</div>
